var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAmazonKinesisDataAnalytics32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_Amazon-Kinesis-Data-Analytics_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_Amazon-Kinesis-Data-Analytics_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Service/32/Amazon-Kinesis-Data-Analytics",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.888,15.913 C7.234,15.913 4,12.024 4,9.706 L3,9.706 C3,13.238 7.767,15.48 17.172,16.413 C7.767,17.346 3,19.587 3,23.119 L4,23.119 C4,20.801 7.234,16.913 28.888,16.913 L28.888,15.913 Z M5.874,26.952 L6.874,26.952 C6.874,24.837 7.51,22.493 11.902,20.855 L11.902,19.794 C6.591,21.656 5.874,24.576 5.874,26.952 L5.874,26.952 Z M8.748,29.826 L9.748,29.826 C9.748,27.933 9.755,25.825 11.902,24.083 L11.902,22.842 C8.752,24.955 8.748,27.747 8.748,29.826 L8.748,29.826 Z M27.931,19.871 L14.931,19.871 L14.931,28.871 L15.931,28.871 L15.931,26.371 C15.931,26.095 16.155,25.871 16.431,25.871 L18.431,25.871 C18.707,25.871 18.931,26.095 18.931,26.371 L18.931,28.871 L19.931,28.871 L19.931,24.371 C19.931,24.095 20.155,23.871 20.431,23.871 L22.431,23.871 C22.707,23.871 22.931,24.095 22.931,24.371 L22.931,28.871 L23.931,28.871 L23.931,22.371 C23.931,22.095 24.155,21.871 24.431,21.871 L26.431,21.871 C26.707,21.871 26.931,22.095 26.931,22.371 L26.931,28.871 L27.931,28.871 L27.931,19.871 Z M24.931,28.871 L25.931,28.871 L25.931,22.871 L24.931,22.871 L24.931,28.871 Z M20.931,28.871 L21.931,28.871 L21.931,24.871 L20.931,24.871 L20.931,28.871 Z M16.931,28.871 L17.931,28.871 L17.931,26.871 L16.931,26.871 L16.931,28.871 Z M28.931,19.371 L28.931,29.371 C28.931,29.647 28.707,29.871 28.431,29.871 L14.431,29.871 C14.155,29.871 13.931,29.647 13.931,29.371 L13.931,19.371 C13.931,19.095 14.155,18.871 14.431,18.871 L28.431,18.871 C28.707,18.871 28.931,19.095 28.931,19.371 L28.931,19.371 Z M28.888,14.997 L28.888,13.997 C9.49,13.997 6.874,9.891 6.874,5.874 L5.874,5.874 C5.874,10.386 8.609,14.997 28.888,14.997 L28.888,14.997 Z M8.748,3 L9.748,3 C9.748,6.617 9.748,12.081 28.888,12.081 L28.888,13.081 C10.303,13.081 8.748,8.101 8.748,3 L8.748,3 Z",
    id: "Amazon-Kinesis-Data-Analytics_Icon_32_Squid"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAmazonKinesisDataAnalytics32);
export default __webpack_public_path__ + "static/media/Arch_Amazon-Kinesis-Data-Analytics_32.68e5424257dbfa65a59bed9353ed5551.svg";
export { ForwardRef as ReactComponent };